import type { ApplicationLoggingAppName } from '@idu-nightlife/nightlife-utils';
import type { Applications } from '../../../../@api-client';

export const APPLICATION_CONTEXT_HEADER = 'x-idu-application';

const APPLICATION_BY_APP_NAME: Partial<Record<ApplicationLoggingAppName, Applications>> = {
  checkd: 'checkd',
  dashd: 'idu_dashboard',
  trackd: 'trackd',
};

export function setApplicationContextHeader(request: Request, appName: ApplicationLoggingAppName) {
  const application = APPLICATION_BY_APP_NAME[appName];

  if (application) {
    request.headers.set(APPLICATION_CONTEXT_HEADER, application);
    return;
  }

  request.headers.delete(APPLICATION_CONTEXT_HEADER);
}
